import {
    CREATE_MY_LIST,
    ADD_MY_LIST_NAME,
    REMOVE_MY_LIST_NAME,
} from '../actionTypes/MyListActionTypes';

export const addMyListName = (data) => ({
    type: ADD_MY_LIST_NAME,
    payload: data,
});

export const removeMyListName = () => ({
    type: REMOVE_MY_LIST_NAME,
});

export const createMyList = (data) => ({
    type: CREATE_MY_LIST,
    payload: data,
});
